import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomCoordiService} from "@/core/service/room.coordi.service";

class RoomCoordiApi extends BaseApi {
    constructor() {
        super()
        Room.Coordi = this

        Room.ready(() => {
            this._eventListen(this.#Events);
        });
    }
    #Events = {
        room_cstudy_changeUserSticker(e){
            Room.emit(e);
        }
    }
    async getUserStickerList(data) {
        return await roomCoordiService.getUserStickerList(data);
    }
    async getPurchaseStickerList(){
        return await roomCoordiService.getPurchaseStickerList();
    }
    async getStickerList(data){
        return await roomCoordiService.getStickerList(data);
    }
    async getStickerItems(itemId) {
        return await roomCoordiService.getStickerItems(itemId);
    }
    async setUserSticker(data){
        return await roomCoordiService.setUserSticker(data);
    }
}

export const roomCoordiApi = new RoomCoordiApi();